import { useEffect } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

// Handles the Stripe return (?session_id=... or ?cancelled=1) on /tavoli
export default function usePaymentReturn(params, onPaid) {
  useEffect(() => {
    const sid = params.get("session_id");
    let stopped = false;
    if (sid) {
      let tries = 0;
      const poll = async () => {
        if (stopped) { return; }
        tries++;
        try {
          const { data } = await api.get(`/payments/checkout/${sid}/status`);
          if (data.payment_status === "paid") {
            toast.success("Caparra confermata! Posto bloccato. Ti abbiamo inviato la ricevuta via email.", { id: "pay-ok" });
            onPaid();
            return;
          }
          if (data.status === "expired" || tries > 8) { toast.error("Pagamento non completato.", { id: "pay-ko" }); return; }
          setTimeout(poll, 2000);
        } catch (e) { toast.error("Errore verifica pagamento", { id: "pay-err" }); }
      };
      poll();
    }
    if (params.get("cancelled")) { setTimeout(() => toast.warning("Pagamento annullato", { id: "pay-cancelled" }), 0); }
    return () => { stopped = true; };
  }, [params, onPaid]);
}
